import React, { createContext, useContext, useState, useCallback, useEffect } from 'react';

const LANG_KEY = 'gh_lang';

export const LANGS = [
  { code: 'zh', label: '\u4e2d\u6587', flag: '\ud83c\udde8\ud83c\uddf3' },
  { code: 'en', label: 'English', flag: '\ud83c\uddec\ud83c\udde7' },
  { code: 'ja', label: '\u65e5\u672c\u8a9e', flag: '\ud83c\uddef\ud83c\uddf5' }
];

export const dict = {
  zh: {
    // 通用
    appName: 'Global Heart', appSlogan: '让认真对待感情的人，遇见彼此。',
    freeStart: '免费开始', login: '登录', register: '注册', logout: '退出登录',
    alreadyAccount: '已有账号，登录 →', noAccount: '没有账号？', createAccount: '创建账号',
    username: '用户名', password: '密码', confirmPassword: '确认密码', email: '邮箱',
    displayName: '昵称', country: '国家', language: '语言', submit: '提交', cancel: '取消',
    confirm: '确认', delete: '删除', edit: '编辑', save: '保存', back: '返回', next: '下一步',
    loading: '加载中...', error: '出错了', success: '成功', retry: '重试', search: '搜索',
    online: '在线', offline: '离线', connected: '已连接', disconnected: '离线', reconnecting: '重连中...',
    connectionStatus: '连接状态', unread: '未读', read: '已读', all: '全部',
    notLoggedIn: '未登录', welcome: '欢迎', profile: '个人资料', settings: '设置',
    home: '首页', discover: '发现', messages: '消息', friends: '好友', moments: '动态',
    community: '社区', marketplace: '商城', shop: '店铺', pricing: '会员', download: '下载',
    admin: '管理后台', chat: '聊天', send: '发送', typeMessage: '输入消息...',
    close: '关闭', open: '打开', more: '更多', less: '更少', yes: '是', no: '否',
    today: '今天', yesterday: '昨天', justNow: '刚刚', minutesAgo: '分钟前', hoursAgo: '小时前',
    daysAgo: '天前', viewAll: '查看全部', empty: '暂无内容', noData: '暂无数据',
    total: '总计', price: '价格', quantity: '数量', order: '订单', status: '状态',
    time: '时间', date: '日期', actions: '操作', details: '详情', description: '描述',
    verify: '验证', verified: '已认证', member: '会员', free: '免费', basic: '基础', vip: 'VIP',
    skip: '跳过', continue: '继续', start: '开始', finish: '完成', done: '完成',

    // 导航
    navHome: '首页', navDiscover: '发现', navMessages: '消息', navFriends: '好友',
    navMoments: '动态', navCommunity: '社区', navShop: '商城', navPricing: '会员',
    navProfile: '我的', navAdmin: '管理',

    // 登录/注册
    loginTitle: '欢迎回来', loginSubtitle: '登录 Global Heart，继续你的连接之旅',
    loginBtn: '登录', loginLoading: '登录中...', loginSuccess: '登录成功',
    loginFail: '用户名或密码错误', loginRequired: '请输入用户名和密码',
    registerTitle: '创建账号', registerSubtitle: '加入 Global Heart，遇见世界',
    registerBtn: '注册', registerLoading: '注册中...', registerSuccess: '注册成功，请登录',
    registerFail: '注册失败', registerUserExists: '用户名已存在', registerWeakPwd: '密码至少6位',
    registerRequired: '请填写所有必填项', pwdMismatch: '两次输入的密码不一致',
    loginHere: '已有账号？去登录', registerHere: '没有账号？去注册',
    usernamePh: '输入用户名', passwordPh: '输入密码', confirmPwdPh: '再次输入密码',
    displayNamePh: '输入昵称（可选）', countryPh: '选择国家', emailPh: '输入邮箱（可选）',

    // 发现页
    discoverTitle: '发现', discoverSubtitle: '认识新朋友',
    discoverNearby: '附近的人', discoverGlobal: '全球用户',
    discoverEmpty: '暂时没有更多用户了', discoverFilter: '筛选',
    discoverCountry: '国家', discoverAll: '全部国家', discoverRefresh: '换一批',

    // 个人资料
    profileTitle: '个人资料', profileEdit: '编辑资料', profileAbout: '关于我',
    profileInterests: '兴趣', profilePhotos: '照片', profileStats: '统计',
    profileMember: '会员状态', profileJoined: '加入时间', profileLocation: '所在地',

    // 聊天
    chatTitle: '聊天', chatEmpty: '还没有聊天', chatStart: '开始聊天吧',
    chatTranslate: '翻译', chatAutoTranslate: '自动翻译', chatOriginal: '原文',

    // 好友
    friendsTitle: '好友', friendsRequests: '好友请求', friendsEmpty: '还没有好友',
    friendsAdd: '添加好友', friendsAccept: '接受', friendsReject: '拒绝',
    friendsPending: '待处理', friendsSearch: '搜索好友',

    // 动态
    momentsTitle: '动态', momentsPost: '发布动态', momentsEmpty: '还没有动态',
    momentsLikes: '赞', momentsComments: '评论', momentsShare: '分享',
    momentsWrite: '说点什么...', momentsPostBtn: '发布',

    // 社区
    communityTitle: '社区', communityNewPost: '发帖', communityEmpty: '还没有帖子',
    communityReply: '回复', communityLikes: '点赞', communityDelete: '删除',

    // 商城
    shopTitle: '商城', cartTitle: '购物车', ordersTitle: '我的订单',
    addToCart: '加入购物车', buyNow: '立即购买', checkout: '去结算',
    cartEmpty: '购物车是空的', cartTotal: '合计', placeOrder: '提交订单',
    orderPending: '待支付', orderPaid: '已支付', orderShipped: '已发货', orderDone: '已完成',
    orderEmpty: '还没有订单', orderNo: '订单号', payNow: '立即支付',
    productDesc: '商品描述', productPrice: '价格', productStock: '库存', soldOut: '已售罄',

    // 会员
    pricingTitle: '会员中心', pricingSubtitle: '选择适合你的会员等级',
    pricingFree: '免费版', pricingBasic: '基础版', pricingVip: 'VIP 版',
    pricingMonth: '/月', pricingChoose: '选择', pricingCurrent: '当前等级',
    pricingFeatures: '会员权益', upgrade: '升级', subscribe: '订阅',

    // 下载
    downloadTitle: '下载 App', downloadSubtitle: '随时随地保持连接',
    downloadAndroid: 'Android 下载', downloadIos: 'iOS 下载', downloadSoon: '即将推出',

    // 其他
    contactUs: '联系我们', contactTitle: '反馈与建议', contactName: '姓名',
    contactType: '类型', contactMsg: '内容', contactSubmit: '提交反馈',
    feedbackType: ['建议', '问题', '其他'],
    healthTitle: '健康检查', healthStatus: '系统状态', healthOk: '正常', healthError: '异常',
    onlineCount: '在线人数', totalUsers: '总用户数', totalMessages: '总消息数',

    // 18+ 验证
    adultTitle: '成人内容确认', adultText: '本网站仅限 18 岁以上用户访问，继续即表示你已年满 18 周岁。',
    adultEnter: '我已满 18 岁，进入', adultExit: '退出',

    // 语言选择
    langTitle: '界面语言', langTip: '选择你喜欢的界面语言',

    // 连接
    connConnected: '已连接', connDisconnected: '离线', connReconnecting: '重连中...',
    memberBadge: { free: '🆓 免费', basic: '💎 基础', vip: '👑 VIP' }
  },

  en: {
    appName: 'Global Heart', appSlogan: 'For those serious about love, find each other.',
    freeStart: 'Start Free', login: 'Log In', register: 'Sign Up', logout: 'Log Out',
    alreadyAccount: 'Have an account? Log in →', noAccount: 'No account?', createAccount: 'Create Account',
    username: 'Username', password: 'Password', confirmPassword: 'Confirm Password', email: 'Email',
    displayName: 'Display Name', country: 'Country', language: 'Language', submit: 'Submit', cancel: 'Cancel',
    confirm: 'Confirm', delete: 'Delete', edit: 'Edit', save: 'Save', back: 'Back', next: 'Next',
    loading: 'Loading...', error: 'Error', success: 'Success', retry: 'Retry', search: 'Search',
    online: 'Online', offline: 'Offline', connected: 'Connected', disconnected: 'Offline', reconnecting: 'Reconnecting...',
    connectionStatus: 'Connection', unread: 'Unread', read: 'Read', all: 'All',
    notLoggedIn: 'Not logged in', welcome: 'Welcome', profile: 'Profile', settings: 'Settings',
    home: 'Home', discover: 'Discover', messages: 'Messages', friends: 'Friends', moments: 'Moments',
    community: 'Community', marketplace: 'Marketplace', shop: 'Shop', pricing: 'Premium', download: 'Download',
    admin: 'Admin', chat: 'Chat', send: 'Send', typeMessage: 'Type a message...',
    close: 'Close', open: 'Open', more: 'More', less: 'Less', yes: 'Yes', no: 'No',
    today: 'Today', yesterday: 'Yesterday', justNow: 'Just now', minutesAgo: 'm ago', hoursAgo: 'h ago',
    daysAgo: 'd ago', viewAll: 'View all', empty: 'Nothing here', noData: 'No data',
    total: 'Total', price: 'Price', quantity: 'Qty', order: 'Order', status: 'Status',
    time: 'Time', date: 'Date', actions: 'Actions', details: 'Details', description: 'Description',
    verify: 'Verify', verified: 'Verified', member: 'Member', free: 'Free', basic: 'Basic', vip: 'VIP',
    skip: 'Skip', continue: 'Continue', start: 'Start', finish: 'Finish', done: 'Done',

    navHome: 'Home', navDiscover: 'Discover', navMessages: 'Messages', navFriends: 'Friends',
    navMoments: 'Moments', navCommunity: 'Community', navShop: 'Shop', navPricing: 'Premium',
    navProfile: 'Me', navAdmin: 'Admin',

    loginTitle: 'Welcome back', loginSubtitle: 'Log in to Global Heart and continue your journey',
    loginBtn: 'Log In', loginLoading: 'Logging in...', loginSuccess: 'Logged in',
    loginFail: 'Wrong username or password', loginRequired: 'Enter username and password',
    registerTitle: 'Create Account', registerSubtitle: 'Join Global Heart, meet the world',
    registerBtn: 'Sign Up', registerLoading: 'Creating...', registerSuccess: 'Registered! Please log in',
    registerFail: 'Registration failed', registerUserExists: 'Username already taken',
    registerWeakPwd: 'Password must be at least 6 characters', registerRequired: 'Fill in all required fields',
    pwdMismatch: 'Passwords do not match',
    loginHere: 'Have an account? Log in', registerHere: 'No account? Sign up',
    usernamePh: 'Enter username', passwordPh: 'Enter password', confirmPwdPh: 'Re-enter password',
    displayNamePh: 'Display name (optional)', countryPh: 'Select country', emailPh: 'Email (optional)',

    discoverTitle: 'Discover', discoverSubtitle: 'Meet new people',
    discoverNearby: 'Nearby', discoverGlobal: 'Global',
    discoverEmpty: 'No more users for now', discoverFilter: 'Filter',
    discoverCountry: 'Country', discoverAll: 'All countries', discoverRefresh: 'Refresh',

    profileTitle: 'Profile', profileEdit: 'Edit Profile', profileAbout: 'About Me',
    profileInterests: 'Interests', profilePhotos: 'Photos', profileStats: 'Stats',
    profileMember: 'Membership', profileJoined: 'Joined', profileLocation: 'Location',

    chatTitle: 'Chat', chatEmpty: 'No conversations yet', chatStart: 'Start chatting',
    chatTranslate: 'Translate', chatAutoTranslate: 'Auto-translate', chatOriginal: 'Original',

    friendsTitle: 'Friends', friendsRequests: 'Friend Requests', friendsEmpty: 'No friends yet',
    friendsAdd: 'Add Friend', friendsAccept: 'Accept', friendsReject: 'Decline',
    friendsPending: 'Pending', friendsSearch: 'Search friends',

    momentsTitle: 'Moments', momentsPost: 'New Post', momentsEmpty: 'No moments yet',
    momentsLikes: 'Likes', momentsComments: 'Comments', momentsShare: 'Share',
    momentsWrite: 'Share something...', momentsPostBtn: 'Post',

    communityTitle: 'Community', communityNewPost: 'New Post', communityEmpty: 'No posts yet',
    communityReply: 'Reply', communityLikes: 'Like', communityDelete: 'Delete',

    shopTitle: 'Marketplace', cartTitle: 'Cart', ordersTitle: 'My Orders',
    addToCart: 'Add to Cart', buyNow: 'Buy Now', checkout: 'Checkout',
    cartEmpty: 'Your cart is empty', cartTotal: 'Total', placeOrder: 'Place Order',
    orderPending: 'Pending', orderPaid: 'Paid', orderShipped: 'Shipped', orderDone: 'Completed',
    orderEmpty: 'No orders yet', orderNo: 'Order No.', payNow: 'Pay Now',
    productDesc: 'Description', productPrice: 'Price', productStock: 'Stock', soldOut: 'Sold Out',

    pricingTitle: 'Premium', pricingSubtitle: 'Choose the plan that fits you',
    pricingFree: 'Free', pricingBasic: 'Basic', pricingVip: 'VIP',
    pricingMonth: '/mo', pricingChoose: 'Choose', pricingCurrent: 'Current Plan',
    pricingFeatures: 'Benefits', upgrade: 'Upgrade', subscribe: 'Subscribe',

    downloadTitle: 'Download App', downloadSubtitle: 'Stay connected anywhere',
    downloadAndroid: 'Android Download', downloadIos: 'iOS Download', downloadSoon: 'Coming Soon',

    contactUs: 'Contact Us', contactTitle: 'Feedback', contactName: 'Name',
    contactType: 'Type', contactMsg: 'Message', contactSubmit: 'Submit',
    feedbackType: ['Suggestion', 'Issue', 'Other'],
    healthTitle: 'Health Check', healthStatus: 'System Status', healthOk: 'Healthy', healthError: 'Error',
    onlineCount: 'Online Now', totalUsers: 'Total Users', totalMessages: 'Total Messages',

    adultTitle: 'Adult Content Notice', adultText: 'This site is for users 18 and older. By continuing you confirm you are at least 18.',
    adultEnter: 'I am 18+, Enter', adultExit: 'Exit',

    langTitle: 'Interface Language', langTip: 'Choose your preferred language',

    connConnected: 'Connected', connDisconnected: 'Offline', connReconnecting: 'Reconnecting...',
    memberBadge: { free: '🆓 Free', basic: '💎 Basic', vip: '👑 VIP' }
  },

  ja: {
    appName: 'Global Heart', appSlogan: '真剣に向き合う人と、ちゃんと出会う。',
    freeStart: '無料で始める', login: 'ログイン', register: '新規登録', logout: 'ログアウト',
    alreadyAccount: 'アカウントをお持ちの方 →', noAccount: 'アカウントをお持ちでない方？', createAccount: 'アカウント作成',
    username: 'ユーザー名', password: 'パスワード', confirmPassword: 'パスワード（確認）', email: 'メール',
    displayName: 'ニックネーム', country: '国', language: '言語', submit: '送信', cancel: 'キャンセル',
    confirm: '確認', delete: '削除', edit: '編集', save: '保存', back: '戻る', next: '次へ',
    loading: '読み込み中...', error: 'エラー', success: '成功', retry: '再試行', search: '検索',
    online: 'オンライン', offline: 'オフライン', connected: '接続済み', disconnected: 'オフライン', reconnecting: '再接続中...',
    connectionStatus: '接続状態', unread: '未読', read: '既読', all: 'すべて',
    notLoggedIn: '未ログイン', welcome: 'ようこそ', profile: 'プロフィール', settings: '設定',
    home: 'ホーム', discover: '発見', messages: 'メッセージ', friends: '友達', moments: 'モーメント',
    community: 'コミュニティ', marketplace: 'マーケット', shop: 'ショップ', pricing: 'プレミアム', download: 'ダウンロード',
    admin: '管理画面', chat: 'チャット', send: '送信', typeMessage: 'メッセージを入力...',
    close: '閉じる', open: '開く', more: 'もっと見る', less: '閉じる', yes: 'はい', no: 'いいえ',
    today: '今日', yesterday: '昨日', justNow: 'たった今', minutesAgo: '分前', hoursAgo: '時間前',
    daysAgo: '日前', viewAll: 'すべて見る', empty: 'まだ何もありません', noData: 'データなし',
    total: '合計', price: '価格', quantity: '数量', order: '注文', status: 'ステータス',
    time: '時間', date: '日付', actions: '操作', details: '詳細', description: '説明',
    verify: '認証', verified: '認証済み', member: '会員', free: '無料', basic: 'ベーシック', vip: 'VIP',
    skip: 'スキップ', continue: '続ける', start: '開始', finish: '完了', done: '完了',

    navHome: 'ホーム', navDiscover: '発見', navMessages: 'メッセージ', navFriends: '友達',
    navMoments: 'モーメント', navCommunity: 'コミュニティ', navShop: 'ショップ', navPricing: 'プレミアム',
    navProfile: 'マイページ', navAdmin: '管理',

    loginTitle: 'おかえりなさい', loginSubtitle: 'Global Heart にログインして旅を続けよう',
    loginBtn: 'ログイン', loginLoading: 'ログイン中...', loginSuccess: 'ログインしました',
    loginFail: 'ユーザー名またはパスワードが違います', loginRequired: 'ユーザー名とパスワードを入力してください',
    registerTitle: 'アカウント作成', registerSubtitle: 'Global Heart に参加して世界と出会おう',
    registerBtn: '登録する', registerLoading: '登録中...', registerSuccess: '登録完了！ログインしてください',
    registerFail: '登録に失敗しました', registerUserExists: 'このユーザー名は既に使われています',
    registerWeakPwd: 'パスワードは6文字以上にしてください', registerRequired: '必須項目をすべて入力してください',
    pwdMismatch: 'パスワードが一致しません',
    loginHere: 'アカウントをお持ちの方はログイン', registerHere: 'アカウントをお持ちでない方は新規登録',
    usernamePh: 'ユーザー名を入力', passwordPh: 'パスワードを入力', confirmPwdPh: 'パスワードを再入力',
    displayNamePh: 'ニックネーム（任意）', countryPh: '国を選択', emailPh: 'メール（任意）',

    discoverTitle: '発見', discoverSubtitle: '新しい出会い',
    discoverNearby: '近くの人', discoverGlobal: '世界中',
    discoverEmpty: '他にユーザーがいません', discoverFilter: '絞り込み',
    discoverCountry: '国', discoverAll: 'すべての国', discoverRefresh: '更新',

    profileTitle: 'プロフィール', profileEdit: 'プロフィール編集', profileAbout: '自己紹介',
    profileInterests: '趣味・興味', profilePhotos: '写真', profileStats: '統計',
    profileMember: '会員ステータス', profileJoined: '登録日', profileLocation: '所在地',

    chatTitle: 'チャット', chatEmpty: 'まだ会話がありません', chatStart: '会話を始めよう',
    chatTranslate: '翻訳', chatAutoTranslate: '自動翻訳', chatOriginal: '原文',

    friendsTitle: '友達', friendsRequests: '友達リクエスト', friendsEmpty: 'まだ友達がいません',
    friendsAdd: '友達追加', friendsAccept: '承認', friendsReject: '拒否',
    friendsPending: '保留中', friendsSearch: '友達を検索',

    momentsTitle: 'モーメント', momentsPost: '投稿する', momentsEmpty: 'まだ投稿がありません',
    momentsLikes: 'いいね', momentsComments: 'コメント', momentsShare: 'シェア',
    momentsWrite: '何かシェアしましょう...', momentsPostBtn: '投稿',

    communityTitle: 'コミュニティ', communityNewPost: '投稿する', communityEmpty: 'まだ投稿がありません',
    communityReply: '返信', communityLikes: 'いいね', communityDelete: '削除',

    shopTitle: 'マーケット', cartTitle: 'カート', ordersTitle: '注文履歴',
    addToCart: 'カートに追加', buyNow: 'すぐ購入', checkout: 'レジへ進む',
    cartEmpty: 'カートは空です', cartTotal: '合計', placeOrder: '注文を確定',
    orderPending: '支払い待ち', orderPaid: '支払い済み', orderShipped: '発送済み', orderDone: '完了',
    orderEmpty: '注文履歴がありません', orderNo: '注文番号', payNow: '今すぐ支払う',
    productDesc: '商品説明', productPrice: '価格', productStock: '在庫', soldOut: '売り切れ',

    pricingTitle: 'プレミアム会員', pricingSubtitle: '自分に合ったプランを選ぼう',
    pricingFree: '無料版', pricingBasic: 'ベーシック', pricingVip: 'VIP',
    pricingMonth: '/月', pricingChoose: '選択', pricingCurrent: '現在のプラン',
    pricingFeatures: '特典', upgrade: 'アップグレード', subscribe: '登録する',

    downloadTitle: 'アプリをダウンロード', downloadSubtitle: 'どこでもつながろう',
    downloadAndroid: 'Android ダウンロード', downloadIos: 'iOS ダウンロード', downloadSoon: '近日公開',

    contactUs: 'お問い合わせ', contactTitle: 'フィードバック', contactName: 'お名前',
    contactType: '種類', contactMsg: '内容', contactSubmit: '送信する',
    feedbackType: ['提案', '問題', 'その他'],
    healthTitle: 'ヘルスチェック', healthStatus: 'システム状態', healthOk: '正常', healthError: '異常',
    onlineCount: 'オンライン人数', totalUsers: '総ユーザー数', totalMessages: '総メッセージ数',

    adultTitle: 'アダルトコンテンツ確認', adultText: 'このサイトは18歳以上の方を対象としています。続行することで18歳以上であることを確認します。',
    adultEnter: '18歳以上です、入る', adultExit: '退出',

    langTitle: '表示言語', langTip: '表示言語を選択してください',

    connConnected: '接続済み', connDisconnected: 'オフライン', connReconnecting: '再接続中...',
    memberBadge: { free: '🆓 無料', basic: '💎 ベーシック', vip: '👑 VIP' }
  }
};

const LanguageContext = createContext(null);

export function LanguageProvider({ children }) {
  const [lang, setLang] = useState(() => {
    try {
      const saved = localStorage.getItem(LANG_KEY);
      if (saved && dict[saved]) return saved;
      const nav = (navigator.language || '').toLowerCase();
      if (nav.startsWith('ja')) return 'ja';
      if (nav.startsWith('zh')) return 'zh';
      if (nav.startsWith('en')) return 'en';
    } catch (_) {}
    return 'zh';
  });

  useEffect(() => {
    try { localStorage.setItem(LANG_KEY, lang); } catch (_) {}
  }, [lang]);

  const t = useCallback((key) => {
    const d = dict[lang] || dict.zh;
    return d[key] !== undefined ? d[key] : (dict.zh[key] !== undefined ? dict.zh[key] : key);
  }, [lang]);

  const setLanguage = useCallback((code) => {
    if (dict[code]) setLang(code);
  }, []);

  const value = { lang, setLanguage, t, LANGS };

  return <LanguageContext.Provider value={value}>{children}</LanguageContext.Provider>;
}

export function useI18n() {
  const ctx = useContext(LanguageContext);
  if (!ctx) throw new Error('useI18n must be used within LanguageProvider');
  return ctx;
}

export default useI18n;
